module.exports = __webpack_public_path__ + "img/furniture.e8f8df60.png";